import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TemplateTableRow, { TemplateTableRowProps } from './TemplateTableRow';

export type TemplateTableProps = {
  columns: string[]
  rows: TemplateTableRowProps[]
  values: any;
  onCheckboxChange: (fieldName: string, isChecked: boolean) => void;
};

const TemplateTable = ({ columns, rows, onCheckboxChange }: TemplateTableProps) => {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';


  return (
        <Table>
            <TableHead>
                <TableRow
                    sx={{
                      backgroundColor: isLight ? theme.palette.grey[200] : theme.palette.grey[900],
                      borderLeft: `1px solid ${isLight ? theme.palette.grey[200] : theme.palette.grey[900]}`,
                      borderRight: `1px solid ${isLight ? theme.palette.grey[200] : theme.palette.grey[900]}`,
                    }}
                >
                    {
                        columns.map((column, index) => (
                            <TableCell
                                key={index}
                                sx={{
                                  minWidth: 160
                                }}
                            >
                                {column}
                            </TableCell>
                        ))
                    }
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    rows.map((row) => (
                        <TemplateTableRow
                            key={row.key}
                            title={row.title}
                            dataType={row.dataType}
                            isVerifiable={row.isVerifiable}
                            verificationExplanation={row.verificationExplanation}
                            captureFieldName={row.captureFieldName}
                            verifyFieldName={row.verifyFieldName}
                            requiredFieldName={row.requiredFieldName}
                            onCheckboxChange={onCheckboxChange}
                        />
                    ))
                }
            </TableBody>
        </Table>
  );
};

export default TemplateTable;
